// The trading houses beyond the map. Cosmetic today — a name on the offer and
// in the event log — but a route remembers which house opened it.
import type { MessageKey } from '../i18n/index.js';

const HOUSE_KEYS: readonly MessageKey[] = ['sea.house1', 'sea.house2', 'sea.house3'];

/** The name of a trading house. */
export function houseName(house: number): MessageKey {
  return HOUSE_KEYS[house] ?? 'sea.house1';
}
